
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.23 2.833c.279 0 .504.224.504.5v3.822c0 .276-.225.5-.503.5H4.196a.502.502 0 01-.504-.5V3.333c0-.276.226-.5.504-.5H9.23zm-.925.967c.175 0 .316.14.316.311V6.49a.313.313 0 01-.316.311H5.147a.313.313 0 01-.315-.311V4.11c0-.172.14-.311.315-.311h3.158z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.51.177a.57.57 0 00-.8-.025.556.556 0 00-.025.792l1.635 1.722-.93 1.307a.555.555 0 00-.036.587c.1.187.299.301.513.296l2-.048v7.145c0 .234-.013.402-.102.526-.06.085-.255.284-.968.284-.633 0-.795-.188-.846-.266-.086-.13-.098-.308-.098-.544V8.591c0-1.214-.98-1.93-1.888-1.93h-.755V.687c0-.276-.226-.5-.504-.5H1.636a.502.502 0 00-.503.5v14.192H.564a.562.562 0 00-.564.56c0 .31.253.561.564.561h12.214c.312 0 .565-.25.565-.56 0-.31-.253-.56-.565-.56h-.568V7.781h.755c.351 0 .755.28.755.81V11.976c0 .214-.001.7.28 1.13.326.497.92.776 1.797.776.924 0 1.546-.268 1.895-.76.31-.434.308-.931.308-1.147V4.233a.556.556 0 00-.134-.361l-1.385-1.62a.543.543 0 00-.02-.02L14.512.176zM2.267 1.682V14.88h8.81V1.682a.376.376 0 00-.377-.375H2.643a.376.376 0 00-.377.375z","fill":"currentColor"}})])
          )
        }
      }
    